import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { demoPageUrl, financeReportPageUrl, marketReportPageUrl } from '../../../alchemy-static-page-urls';

const RefreshRecommendations = ({ className }) => (
  <div className={cx(className)}>
    <div className="recommendation-state recommendation-state-refresh">
      <div className="recommendation-state-header">
        <span>Report updated! Check your inbox</span>
        <span className="hicon-check-bold" />
      </div>
      <div className="recommendation-state-body">
        <div className="recommendation-state-body-top">
          <div className="recommendation-bubbles" />
          <p className="text-white text-24 text-center">Want data on a different <br /> group of competitors?</p>
          <a className="btn text-16" href={marketReportPageUrl}>Create new report</a>
        </div>
        <div className="recommendation-state-body-bottom">
          <p className="text-black text-16 text-center">Want insights on the Top 50 public <br /> companies worldwide?</p>
          <a className="link-with-angle link-with-prefix-icon" href={financeReportPageUrl}>Get free company insights</a>
        </div>
      </div>
      <div className="recommendation-state-footer">
        <p className="text-black text-16">Have questions? <a className="text-blue" href={demoPageUrl} target="_blank" rel="noopener noreferrer">Talk to us!</a></p>
      </div>
    </div>
  </div>
);

RefreshRecommendations.propTypes = {
  className: T.string,
};

export default RefreshRecommendations;
